import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules";

Vue.config.devtools = process.env.VUE_APP_DEVTOOLS_ENABLED;

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  modules
});
